import React from 'react';

import { Route as BrowserRoute, RouteProps } from 'react-router-dom';

import { PageTransition } from '../PageTransition/PageTransition';

export interface LazyLoadedBrowserRouteProps extends RouteProps {
    /** Fallback to render while the component is being downloaded */
    fallback?: React.ReactNode;
    /** Route to render. */
    children?: React.ReactNode;
}

/**
 * Route component that wraps the children routes in a React suspense.
 * This can be useful if you don't want to wrap the whole router in a suspense, causing the
 * previous route to remain in the dom in display: none while the new one downloads
 */
export const LazyLoadedBrowserRoute: React.FC<LazyLoadedBrowserRouteProps> = ({
    children,
    fallback,
    ...routeProps
}) => (
    <BrowserRoute {...routeProps}>
        <React.Suspense fallback={fallback || <PageTransition />}>{children}</React.Suspense>
    </BrowserRoute>
);
